import React from 'react';
import { NavigationContainer } from './navigation/navigation';
import './App.css';
import { Provider } from 'react-redux';
import { persistor, store } from './store/store';
import { PersistGate } from 'redux-persist/integration/react';
import { FormikProvider } from 'formik';

const App = () => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        {(formikProps) => (
          <FormikProvider value={formikProps as any}>
            <NavigationContainer />
          </FormikProvider>
        )}
      </PersistGate>
    </Provider>
  );
};

export default App;
